<template>
  <b-container>
    <div
      class="goldpattern text-white text-shadow border border-secondary rounded px-3 py-2 mt-2 head-tab"
    >
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 text-center text-sm-center text-md-left">
          <div class="indexlogo">
            <div class="logoindex">
              <router-link to="/">
                <img
                  :alt="getAppName"
                  class="d-inline-block"
                  height="40"
                  src="../../assets/images/logo.png"
                />
                <h3 class="d-inline-block align-middle ml-2 mb-0 text">{{getAppName}}</h3>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 text-center text-sm-center text-md-right">
          <h3 class="my-1">ลืมรหัสผ่าน</h3>
        </div>
      </div>
    </div>
    <forgot-password-step-1 v-if="step == 'step-1'" @setPhone="setNewPhone"></forgot-password-step-1>
    <forgot-password-step-2 v-else-if="step == 'step-2'" :mobile.sync="userInfo.mobile" :username.sync="userInfo.username" :refCode.sync="otpCode.refCode" @enterOTP="enterOTP" @getOTP="getOTP"></forgot-password-step-2>
    <forgot-password-step-3 v-else-if="step == 'step-3'" :username.sync="userInfo.username" @enterPassword="enterPassword"></forgot-password-step-3>
    <forgot-password-step-4 v-else-if="step == 'step-4'"></forgot-password-step-4>
  </b-container>
</template>

<script>
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

// Include Component
import ForgotPasswordStep1 from "@/components/forgotPassword/Step1.vue";
import ForgotPasswordStep2 from "@/components/forgotPassword/Step2.vue";
import ForgotPasswordStep3 from "@/components/forgotPassword/Step3.vue";
import ForgotPasswordStep4 from "@/components/forgotPassword/Step4.vue";

export default {
  name: 'ForgotPassword',
  props: ['step'],
  components: {
    "forgot-password-step-1": ForgotPasswordStep1,
    "forgot-password-step-2": ForgotPasswordStep2,
    "forgot-password-step-3": ForgotPasswordStep3,
    "forgot-password-step-4": ForgotPasswordStep4
  },
  data() {
    return {
      userInfo: {
        mobile: "",
        username: ""
      },
      otpCode: {
        otp: null,
        refCode: null
      }
    }
  },
  methods: {
    setNewPhone(userInfo) {
      console.log(userInfo);
      this.userInfo = userInfo;
      this.getOTP();
    },
    getOTP() {
      axios
        .post(
          this.getApiUrl + "/customer/getotpforgotpassword", this.userInfo,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.otpCode = response.data.data;
            this.$router.push("/forgot-password/step-2");
          }
          else {
            this.$bvToast.toast(response.data.message, {
              title: "ลืมรหัสผ่าน",
              variant: "danger",
              solid: true,
              appendToast: true
            });
          }
        });
    },
    enterOTP(code) {
      this.otpCode.otp = code;
      this.$router.push("/forgot-password/step-3");
    },
    enterPassword(password) {
      this.userInfo.password = password.password;
      this.userInfo.confirmPassword = password.confirmPassword;
      axios
        .post(
          this.getApiUrl + "/customer/changeforgotpassword", 
          {
            username: this.userInfo.username,
            otp: this.otpCode.otp,
            password: this.userInfo.password
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
          //   this.otpCode = response.data.data;
            this.$router.push("/forgot-password/step-4");
          }
          else {
            this.$bvToast.toast("หมายเลข OTP ไม่ถูกต้อง", {
              title: "ลืมรหัสผ่าน",
              variant: "danger",
              solid: true,
              appendToast: true
            });
          }
        });
      // this.$router.push("/forgot-password/step-4");
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName"
    })
  }
}
</script>

<style lang="scss" scoped>
.text-shadow {
  text-shadow: rgb(0 0 0 / 50%) 1px 1px 3px;
}

.head-tab {
  h3 {
    font-family: SukhumvitBold;
  }
}

.logoindex {
  /* background: url(../images/logo-fifalotto-white.png) no-repeat top center; */
  background-size: cover;
  height: 40px;
  margin: 0 auto;
  position: relative;
  display: inline-block;
  vertical-align: middle;

  a {
    color: black;
  }
}

.flag-icon {
  img {
    height: 1em;
    line-height: 1em;
  }
}

.item {
  h3 {
    font-size: 150%;
  }

  h4 {
    font-size: 130%;
    color: #bd841b;
  }

  table {
    thead {
      tr {
        th {
          vertical-align: bottom;
          border-bottom: 2px solid #dee2e6;
        }
      }
    }

    tbody {
      tr {
        td.first-val {
          color: rgb(189, 132, 41) !important;
        }
      }
    }

    .text-border-number {
      text-shadow: #fff 2px 0px 0px, #fff 1.75517px 0.958851px 0px,
        #fff 1.0806px 1.68294px 0px, #fff 0.141474px 1.99499px 0px,
        #fff -0.832294px 1.81859px 0px, #fff -1.60229px 1.19694px 0px,
        #fff -1.97998px 0.28224px 0px, #fff -1.87291px -0.701566px 0px,
        #fff -1.30729px -1.5136px 0px, #fff -0.421592px -1.95506px 0px,
        #fff 0.567324px -1.91785px 0px, #fff 1.41734px -1.41108px 0px,
        #fff 1.92034px -0.558831px 0px;
      letter-spacing: 0.04em;
    }
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>